const toLocaleStringSupportsLocales = () => (
  typeof Intl === 'object' &&
  !!Intl &&
  typeof Intl.NumberFormat === 'function'
);

const toLocaleString = (value) => {
  if (toLocaleStringSupportsLocales()) return value.toLocaleString();

  return value;
};

const fromUndefinedToNull = (value) => {
  if (value === undefined) return null;

  return value;
};

// math

const roundToNearest = (number, nearest) => Math.round(number / nearest) * nearest;

const getOrderOfMagnitude = (number) => {
  if (number === 0) return 0;

  const absNumber = Math.abs(number);

  return Math.floor(Math.log10(absNumber));
};

//

const isNullUndefinedOrEmptyString = (value) => value === null || value === undefined || value === '';

export {
  toLocaleString,
  fromUndefinedToNull,
  //
  roundToNearest,
  getOrderOfMagnitude,
  //
  isNullUndefinedOrEmptyString,
};
